export const chipIconProps = { className: 'align-top mr-1' };

export const getFilteredListByKeyField = (list, keyField, valueToFilter) => list?.filter(i => i[keyField] === valueToFilter);

export const OFFICES_POPOVER_WIDTH = '1525px';

// Office.jsx's body root is inset by this amount on each side (margin: '9px 5.5px');
// OfficesChip.jsx's header needs the same horizontal offset so the title/Close button
// align with the body content. Keep these in sync -- see XBM-9887 PR review.
export const OFFICES_POPOVER_HORIZONTAL_INSET = '5.5px';
